module.exports = __webpack_public_path__ + "static/media/bkg.3b526615.jpg";